/* Collections carousel + product — switch active thumb / image / info / product */
(function () {
  function pad2(n) { return ("0" + n).slice(-2); }

  function initCCP(root) {
    if (!root || root.dataset.ccpInit === "1") return;
    root.dataset.ccpInit = "1";

    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-ccp-thumb]"));
    var mobileImgs = Array.prototype.slice.call(root.querySelectorAll("[data-ccp-mobile-img]"));
    var names = Array.prototype.slice.call(root.querySelectorAll("[data-ccp-name]"));
    var descs = Array.prototype.slice.call(root.querySelectorAll("[data-ccp-desc]"));
    var links = Array.prototype.slice.call(root.querySelectorAll("[data-ccp-link]"));
    var products = Array.prototype.slice.call(root.querySelectorAll("[data-ccp-product]"));
    var prevBtns = root.querySelectorAll("[data-ccp-prev]");
    var nextBtns = root.querySelectorAll("[data-ccp-next]");
    var indexEl = root.querySelector("[data-ccp-index]");
    var totalEl = root.querySelector("[data-ccp-total]");

    var total = mobileImgs.length;
    if (total === 0) return;
    if (totalEl) totalEl.textContent = pad2(total);

    var active = 0;

    function setActive(i) {
      active = ((i % total) + total) % total;
      mobileImgs.forEach(function (el, idx) { el.classList.toggle("is-active", idx === active); });
      thumbs.forEach(function (el, idx) { el.classList.toggle("is-hidden", idx === active); });
      names.forEach(function (el, idx) { el.classList.toggle("is-active", idx === active); });
      descs.forEach(function (el, idx) { el.classList.toggle("is-active", idx === active); });
      links.forEach(function (el, idx) { el.classList.toggle("is-active", idx === active); });
      products.forEach(function (el, idx) { el.classList.toggle("is-active", idx === active); });
      if (indexEl) indexEl.textContent = pad2(active + 1);
    }

    thumbs.forEach(function (el, idx) { el.addEventListener("click", function () { setActive(idx); }); });
    prevBtns.forEach(function (b) { b.addEventListener("click", function () { setActive(active - 1); }); });
    nextBtns.forEach(function (b) { b.addEventListener("click", function () { setActive(active + 1); }); });

    setActive(0);
  }

  function initAll() { document.querySelectorAll("[data-ccp]").forEach(initCCP); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", function (e) {
    var s = e.target.querySelector("[data-ccp]"); if (s) initCCP(s);
  });
})();